import React from "react";

const preArrivalNoticeRoutes = [
    {
        path: "/applications/preArrivalNotice/list",
        component: React.lazy(() => import("./PreArrivalNoticeList")),
    },
    {
        path: "/applications/preArrivalNotice/:viewType/:appId",
        component: React.lazy(() => import("./PreArrivalNoticeDetails")),
    },

];

export default preArrivalNoticeRoutes;